
<template>
  <transition name="zoom">
    <div class="danmulist" :style="{height:'calc('+'100% - '+danmuHeight+'px)','top':danmuHeight+'px'}">
      <div class="danmubox">
        <div
          :class="['item',item.type==7 || item.type==4 || item.type==8|| item.type==9?'content_custom':'']"
          v-for="item in list"
          :key="item.unique_id"
        >
          <div class="content expression" v-if="item.type==6">
            <img class="ex_img" :src="item.value" alt>
          </div>
          <div
            :class="['content',item.isOwn? (item.isRight? 'content_right':'content_wrong'):''] "
            v-if="item.type==5"
          >
            <img
              class="duigou_img"
              v-if="item.isRight&&!item.isstandard"
              :src="[item.isOwn?'/static/img/video/duigou_green.png':'/static/img/video/duigou_dark.png']"
              alt
            >
            {{item.value[0]}}
          </div>
          <div
            :class="['content',item.isOwn? (item.isRight? 'content_right':'content_wrong'):''] "
            v-if="item.type==0"
          >
            <img
              class="duigou_img"
              v-if="item.isRight&&!item.isstandard"
              :src="[item.isOwn?'/static/img/video/duigou_green.png':'/static/img/video/duigou_dark.png']"
              alt
            >
            <span class="text">{{item.value[0]}}</span>
          </div>
          <div
            :class="['content',item.isOwn? (item.isRight? 'content_right':'content_wrong'):''] "
            v-if="item.type==7"
          >
            <div :style="setFontColor({'text-align':item.value[0].length>9?'left':'center','color': !item.isQuestion?item.txtColor:'','font-family':item.txtColor?'HYZhengYuan':''}, item)" v-text="item.value[0]"></div>
          </div>
          <div class="content teacher_praise" v-if="item.type==8">
            <span>{{item.value[0]}}“<em>{{item.value[2]}}</em>”{{item.value[1]}}</span>
          </div>
          <div class="content" :class="{'content_right':item.isOwn,'bubbdec':item.imgSrc}"  v-if="item.type==4">
            <img v-if="item.imgSrc" :src="item.imgSrc" alt="">
            <div :style="setFontColor({'color':item.txtColor,'font-family':item.txtColor?'HYZhengYuan':''},item)" v-text="item.value[0]"></div>
          </div>
          <div :class="['content','giftdanmu',item.isOwn? 'content_right':''] " v-if="item.type==9">
            <img :src="item.imgurl" alt="">
            <span>{{item.value[0]}}</span>
          </div>
          <div
            :class="['content',item.isOwn? (item.isRight? 'content_right':'content_wrong'):''] "
            v-if="item.type==3"
          >
            <img
              class="duigou_img"
              v-if="item.isRight&&!item.isstandard"
              :src="[item.isOwn?'static/img/video/duigou_green.png':'/static/img/video/duigou_dark.png']"
              alt
            >
            <div class="pingfang">
              <div v-for="(item1,index1) in item.value" :key="index1">
                <span class="dishu">{{item1[0]}}</span>
                <span class="mi">{{item1[1]}}</span>
              </div>
            </div>
          </div>
          <div
            :class="['content',item.isOwn? (item.isRight? 'content_right':'content_wrong'):''] "
            v-if="item.type==2"
          >
            <img
              class="duigou_img"
              v-if="item.isRight&&!item.isstandard"
              :src="[item.isOwn?'/static/img/video/duigou_green.png':'/static/img/video/duigou_dark.png']"
              alt
            >
            <div class="genhao">
              <div v-for="(item1,index1) in item.value" :key="index1">
                <span v-if="item1.length==1">{{item1[0]}}</span>
                <span v-else>
                  <span class="kaifang">{{item1[0]}}</span>
                  <span class="beikaifang">{{item1[1]}}</span>
                </span>
              </div>
            </div>
          </div>
          <div
            :class="['content',item.isOwn? (item.isRight? 'content_right':'content_wrong'):''] "
            v-if="item.type==1"
          >
            <img
              class="duigou_img"
              v-if="item.isRight&&!item.isstandard"
              :src="[item.isOwn?'/static/img/video/duigou_green.png':'/static/img/video/duigou_dark.png']"
              alt
            >
            <div class="fenshu">
              <div v-for="(item1,index1) in item.value" :key="index1">
                <span class="zhengshu">{{item1.length>1?item1[2]:item1[0]}}</span>
                <span class="fenshi" v-if="item1.length>1">
                  <span class="fenzi">{{item1[0]}}</span>
                  <p class="line"></p>
                  <span class="fenmu">{{item1[1]}}</span>
                </span>
              </div>
            </div>
          </div>
          <span
            v-if="item.type!=6"
            :class="['arrow',item.isOwn? (item.isRight? 'arrow_right':'arrow_wrong'):''] "
          ></span>
          <p class="student_name teacher_name" v-if="item.type==8">
            <img src="../../../assets/img/video/photo_icon.png" alt="">
            <em>主讲老师</em>
          </p>
          <p class="student_name" v-else>
            <img v-if="item.levelUrl" :src="item.levelUrl" alt="">
            <span v-if="item.continuousNum>0" :style="{background:item.bgColor}" :class="[item.levelUrl?'pl_20':'pl_10']">{{item.continuousNum}}连</span>
            <em
              :class="{'pl_10':item.continuousNum==0 && !item.levelUrl,'pl_20':item.levelUrl && item.continuousNum==0,'name_color':item.isOwn}"
            >{{item.name | realSubstring}}</em>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      //type:  0普通文字弹幕  1 分数弹幕 2 根号弹幕  3 平方弹幕  5 其他人弹幕 6表情弹幕 7自定义文字弹幕,8老师表扬弹幕，9学生送礼物弹幕
      // list1: [
      //   {
      //     type: 0,
      //     isOwn: false,
      //     value: ["这道题目有点难啊~"]
      //   },
      //   {
      //     type: 0,
      //     isOwn: true,
      //     value: ["这道题目有点难啊~"]
      //   },
      //   {
      //     type: 0,
      //     isOwn: true,
      //     isRight: true,
      //     value: ["我不懂"]
      //   },
      //   {
      //     type: 0,
      //     isOwn: true,
      //     isRight: false,
      //     value: ["我也不懂~"]
      //   },
      //   {
      //     type: 1,
      //     isOwn: true,
      //     isRight: true,
      //     value: [[11, 11, 22]]
      //   },
      //   {
      //     type: 1,
      //     isOwn: true,
      //     isRight: true,
      //     value: [[222222, 22, 1], ["和"], [222222, 22, 1]]
      //   },
      //   {
      //     type: 2,
      //     name: "",
      //     isOwn: true,
      //     isRight: true,
      //     value: [11, 11]
      //   },
      //   {
      //     type: 2,
      //     isOwn: true,
      //     isRight: false,
      //     value: [22, 22]
      //   },
      //   {
      //     type: 3,
      //     isOwn: true,
      //     isRight: true,
      //     value: [33, 33]
      //   },
      //   {
      //     type: 3,
      //     isOwn: true,
      //     isRight: false,
      //     value: [44, 44]
      //   },

      //   {
      //     type: 5,
      //     isOwn: false,
      //     isRight: false,
      //     value: ["******"]
      //   },
      //   {
      //     type: 5,
      //     isOwn: false,
      //     isRight: true,
      //     value: ["******"]
      //   },
      //   {
      //     type: 6,
      //     value: "../../../assets/img/common/back.png"
      //   }
      // ]
    };
  },
  props: {
    list: {
      type: Array,
      required: false
    },
    danmuHeight:{
      type:Number,
      required:true
    }
  },
  methods: {
    setFontColor(obj, item) {
      if (item.gradient) {
        obj.background = item.gradient
        obj.color = 'transparent'
        obj.webkitBackgroundClip = 'text'
      }
      return obj
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.danmulist {
  position: absolute;
  right: 0;
  top: 50px;
  box-sizing: content-box;
  min-width: 215px;
  z-index: 80;
  pointer-events: none;
  overflow:hidden;
  font-family: "Microsoft YaHei", "黑体", monospace, PingFang_Regular,
    sans-serif, SimHei;
  .danmubox {
    width: 100%;
    text-align: right;
    padding-right: 22px;
    position: absolute;
    bottom: 50px;
    .item {
      position: relative;
      overflow: hidden;
      max-height: none;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      align-items: flex-end;
      font-size: 0;
      &:last-child {
        max-height: 0;
        animation: danmuanimation 1s cubic-bezier(0.745, 0, 0.31, 0.995) both;
      }
      .content {
        font-size: 16px;
        margin-top: 30px;
        display: inline-block;
        min-width: 80px;
        height: 37px;
        max-width: 100%;
        text-align: center;
        background-color: rgba(100, 100, 100, 0.7);
        padding: 0 4px 0 4px;
        color: #fff;
        line-height: 37px;
        border-radius: 21.5px;
        white-space: nowrap;
        .duigou_img {
          width: 23px;
          height: 23px;
          float: left;
          margin-top: 7px;
        }
        .text {
          padding: 0 8px;
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
          max-width: 100%;
        }
        .pingfang {
          clear: both;
          display: inline-block;
          position: relative;
          height: 37px;
          line-height: 25px;
          div {
            display: inline-block;
            .dishu {
              vertical-align: 2px;
              margin-right: -5px;
              font-size: 16px;
            }
            .mi {
              font-size: 12px;
              vertical-align: 10px;
              width: 50%;
            }
          }
        }
        .genhao {
          clear: both;
          display: inline-block;
          position: relative;
          height: 37px;
          padding: 0 8px;
          line-height: 37px;
          div {
            display: inline;
            .beikaifang {
              min-width: 50px;
              display: inline-block;
              height: 26px;
              line-height: 28px;
              background: url("../../../assets/img/video/genhao.png") no-repeat
                top left;
              margin-top: 4px;
              padding-left: 20px;
              text-align: center;
              background-size: 100% 100%;
            }
            .kaifang {
              margin-left: 10px;
              margin-right: -10px;
              display: inline-block;
              transform: translateY(-23%);
            }
          }
        }
        .fenshu {
          display: flex;
          height: 100%;
          line-height: 1.1;
          justify-content: center;
          padding: 0 8px;
          overflow: hidden;
          > div {
            display: flex;
            height: 100%;
            max-width: 100%
          }
          .fenshi {
            justify-content: center;
            display: flex;
            flex-direction: column;
            .line {
              height: 2px;
              background: #fff;
            }
            .fenzi,
            .fenmu {
              min-width: 25px;
              display: inline-block;
              min-height: 16px;
            }
          }
          .zhengshu {
            height: 33px;
            line-height: 33px;
          }
        }
      }
      .bubbdec{
        position: relative;
        margin-top: 55px;
        img{
          position: absolute;
          top: -32px;
          height: 32px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .giftdanmu{
        img{
          transform: translateY(-2px);
          width: 22px;
          height: 22px;
        }
        span{
          white-space: pre-wrap;
        }
      }
      .teacher_praise{
        em{
          margin-top: 5px;
          color:#ffc200;
        }
        span{
          white-space: pre-wrap;
        }
      }
      // .content_right {
      //   // background-color: #00a061;
      // }
      .content_wrong::before {
        content: "";
        width: 23px;
        height: 23px;
        border-radius: 50%;
        background: #FF7C4D;
        float: left;
        margin-top: 7px;
      }

      .expression {
        background: none;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;
        height: 47px;
        .ex_img {
          margin: 0;
          height: 47px;
          //width: 47px;
        }
      }
    }
    .content_custom {
      height: auto;
      white-space: normal;
      .content {
        max-width: 100%;
        word-wrap: break-word;
        text-align: left;
        padding: 10px 14px 10px 16px;
        line-height: 1.3;
        height: auto;
      }
      .content div{
        white-space: pre-wrap;
      }
    }
    .arrow {
      box-sizing: border-box;
      width: 0px;
      height: 0px;
      border-width: 4px;
      margin-right: 35px;
      border-style: solid;
      border-color: rgba(100, 100, 100, 0.7) transparent transparent transparent;
    }
    // .arrow_right {
    //   // border-color: #00a061 transparent transparent transparent;
    // }
    // .arrow_wrong {
    //   // border-color: #f56c22 transparent transparent transparent;
    // }
    .student_name {
      font-size: 0;
      color: #333333;
      height: 22px;
      background: #ffffff;
      padding-right:10px;
      border-radius: 11px;
      position: relative;
      bottom: 1px;
      img{
        position: absolute;
        width: 24px;
        height: 24px;
        top: -1px;
        left: -6px;
        z-index: 2;
      }
      em{
        position: relative;
        display: inline-block;
        z-index: 3;
        padding-left: 3px;
        font-size: 14px;
        overflow: hidden;
        line-height: 22px;
      }
      .name_color{
        color:#009959;
      }
      span{
        position: relative;
        display: inline-block;
        height:100%;
        font-weight: 500;
        font-size: 15px;
        color: #ffffff;
        padding: 0 10px;
        border-radius: 11px 0 0 11px;
        overflow: hidden;
        line-height: 21px;
        background: #7E7B79;
      }
      span::after{
        content: '';
        height: 24px;
        width: 8px;
        position: absolute;
        right: -4px;
        top: 0;
        background: #ffffff;
        transform: rotate(20deg);
      }
      .pl_10{
        padding-left: 10px;
      }
      .pl_20{
        padding-left: 20px;
      }
    }
    .teacher_name{
      background: #008ACF;
      em{
        color:#FFFFFF;
        padding-left: 20px;
      }
    }
  }
}

.gradient{
  -webkit-background-clip: text;
}

.zoom-enter-active {
  animation: zoomIn 0.5s cubic-bezier(0.745, 0, 0.31, 0.995);
}
.zoom-leave-active {
  animation: zoomIn 0.5s reverse cubic-bezier(0.745, 0, 0.31, 0.995);
}
@keyframes danmuanimation {
  0% {
    max-height: 0;
  }
  100% {
    max-height: 700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/danmuList.vue